<main class="esf-main-content esf-main-content--has-sidebar -has-transition" [class.-is-open]="sidebarService.isOpened">
  <div class="esf-container main-content">

    <h1 class="esf-heading esf-heading--page esf-action-heading">
      <span i18n='Main heading for the customer profile component@@customerOverviewComponent.heading.ticketing' class="esf-action-heading__text">Ticketing</span>
    </h1>

    <div class="grid-container">
      <div class="esf-horizontal-tabs">
        <ul class="esf-horizontal-tabs__list">
          <li class="esf-horizontal-tabs__list-item">
            <span class="esf-horizontal-tabs__link" style="cursor: pointer" [attr.aria-selected]="currentlyOpened === 'invoices' ? true : null"
                  (click)="setCurrentlyOpened('invoices')" i18n='Text in a tab element@@general.tabs.invoices'>Invoices</span>
          </li>
          <li class="esf-horizontal-tabs__list-item" *ngIf="!selectedClub.isDataFeedActive">
            <span class="esf-horizontal-tabs__link" style="cursor: pointer" [attr.aria-selected]="currentlyOpened === 'reservations' ? true : null"
                  (click)="setCurrentlyOpened('reservations')">
              <span [ngClass]="{'esf-badge': reservationsComponent?.bookableReservations !== 0 && childrenLoaded}"
                    [attr.data-badge]="reservationsComponent?.bookableReservations || 0"
                    i18n='Text in a tab element@@general.tabs.reservations'>Reservations</span>
            </span>
          </li>
          <li class="esf-horizontal-tabs__list-item">
            <span class="esf-horizontal-tabs__link" style="cursor: pointer" [attr.aria-selected]="currentlyOpened === 'cancellations' ? true : null"
                  (click)="setCurrentlyOpened('cancellations')" i18n='Text in a tab element@@general.tabs.cancellations'>Cancellations</span>
          </li>
        </ul>
        <div class="esf-horizontal-tabs__panels">

          <section class="esf-horizontal-tabs__panel" id="invoices" [hidden]="!(currentlyOpened === 'invoices')">
            <app-page-invoices-list [customer]="customer"></app-page-invoices-list>
          </section>

          <section class="esf-horizontal-tabs__panel" id="reservations" [hidden]="!(currentlyOpened === 'reservations')" *ngIf="!selectedClub.isDataFeedActive">
            <app-page-reservations-list [customer]="customer"></app-page-reservations-list>
          </section>

          <section class="esf-horizontal-tabs__panel" id="cancellations" [hidden]="!(currentlyOpened === 'cancellations')">
            <app-page-cancellations-list [customer]="customer"></app-page-cancellations-list>
          </section>
        </div>
      </div>

    </div>
  </div>
</main>
